import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>
          Welcome
        </p>
        
      </header>
    </div>
  );
}

export default App;
